import { render, staticRenderFns } from "./hotBusinesses.vue?vue&type=template&id=c15a86cc&scoped=true"
import script from "./hotBusinesses.vue?vue&type=script&lang=js"
export * from "./hotBusinesses.vue?vue&type=script&lang=js"
import style0 from "./hotBusinesses.vue?vue&type=style&index=0&id=c15a86cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15a86cc",
  null
  
)

export default component.exports